<div *ngIf="show" class="loader fade show">
  <div class="backdrop"></div>

  <div class="body">
    <div class="icon"></div>
  </div>
</div>
